import { Fragment, useEffect, useState, useRef } from 'react'
import PageLayout from '../Layouts/PageLayout'
import Spinner from '../FieldComponets/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { PAGES } from '../../Constants/CommonConstants';
import { MaterialReactTable } from 'material-react-table'
import { paginationQuery, handleSearch } from '../../utils/GlobalHelper';
import type { ColumnFiltersState, PaginationState } from '@tanstack/react-table';
import React from 'react';
import { getDate, getDateFormatData } from '../../utils/Helper';
import { CustomerGetAction, CustomerStatusAction } from '../../Redux/Action/CustomerAction';
import { Link, useNavigate } from 'react-router-dom';
import { setItemToStorage } from '../../utils/Helper';
import ToastDefault from '../FieldComponets/Toast';
import { DashboardRedirectionAction } from '../../Redux/Action/CommonAction';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { LinkButtons } from "../FieldComponets/LinkButtons";
import { userPicUrl } from '../../utils/Helper';
import { useIntl, FormattedMessage } from 'react-intl';


function CustomerManagement() {

  const intl = useIntl();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const customerlist = useSelector((state: any) => state.CustomerGetState);
  const UpdateStatus = useSelector((state: any) => state.CustomerStatusState)
  const DashboardRedirectionStatedata = useSelector((state: any) => state.DashboardRedirectionState)
  const [data, setData] = useState<any>([]);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [openSerach, setOpenSerach] = useState(false)
  const [sorting, setSorting] = useState<any>(['ASC']);

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: PAGES?.pageIndex,
    pageSize: PAGES?.pageSize
  });
  const [searchValue, setSearchValue] = useState('');
  const [rowCount, setRowCount] = useState(0);
  const [popupdata, setPopudata] = useState<any>({})
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')

  const handleActive = (sendData: { id: any; status: number }): void => {
    // if (window.confirm("Are you Sure to Change Status")) {
    const data = {
      status: sendData.status === 1 ? 0 : 1,
      status_id: sendData.id as any, // Assuming id is of type any
    };
    dispatch(CustomerStatusAction(data));
    // } 
  };

  const NavigateToBookingList =(e:any)=>{
   dispatch(DashboardRedirectionAction({ 'user_id': e?.id }))
   navigate('/booking-list')
  }

  const columns: any = [
    {
      accessorKey: 'S.NO',
      header: intl.formatMessage({ id: 's_no' }),
      accessorFn: (row: Object, index: number) => {
        const currentPage = pagination.pageIndex + 1 || 1; // Assuming current page number, default to 1 if not provided
        const itemsPerPage = pagination.pageSize || 10; // Assuming items per page, default to 10 if not provided
        const startIndex = (currentPage - 1) * itemsPerPage;
        const serialNumber = startIndex + index + 1;
        return serialNumber;
      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
      size: 50,
    },
    {
      accessorKey: 'id',
      header: intl.formatMessage({ id: 'customer_id' }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'profile_pic',
      header: intl.formatMessage({ id: 'profile_picture' }),
      accessorFn: (row: { profile_pic: any; }) =><img src={userPicUrl(row?.profile_pic)} alt='image' width={50} height={50}/>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'name',
      header: intl.formatMessage({ id: 'name' }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
   
    {
      accessorKey: 'phone_number',
      header: intl.formatMessage({ id: 'mobile_number' }),
      accessorFn: (row: { phone_number: any , phone_country_code:any }) => row.phone_number == null ? "----" :<p>{row?.phone_country_code} {row.phone_number}</p>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'email',
      header: intl.formatMessage({ id: 'email' }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'booking_detail',
      header: intl.formatMessage({ id: 'total_bookings' }),
      accessorFn: (row: { booking_details: any}) =>{
      return     <p onClick={()=>NavigateToBookingList(row)} style={{cursor:'pointer' , color:"blue"}} >{row?.booking_details?.length}</p>
      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'created_at1',
      header: intl.formatMessage({ id: 'registration_date' }),
      accessorFn: (row: { created_at: any; }) => getDate(row.created_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },

    {
      header: intl.formatMessage({ id: 'status' }),
      size: 50,
      accessorFn: (row: { id: any, status: number }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <label className="switch">

              <input type="checkbox" checked={row.status == 1} onChange={() => handleActive(row)} />
              <span className="slider round"></span>
            </label>
          </ul>
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      header: intl.formatMessage({ id: 'action' }),
      size: 30,
      accessorFn: (row: { id: any; }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <span>
              <LinkButtons
                pageLink={`customer-details`}
                pageID={row?.id}
                showEdit={false}
                showView={true}
                showDelete={false}
              />
            </span>
          </ul>
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (!data?.length) {
        setLoading(true);
      } else {
        setIsRefetching(true);
      }
      try {
        const userStatus = DashboardRedirectionStatedata?.data?.status;
        let query: any = paginationQuery(
          pagination.pageIndex,
          pagination.pageSize,
          sorting,
          searchValue,
          columnFilters
        );

        query.columnFilters.push({ id: "status", value: userStatus })


        dispatch(DashboardRedirectionAction('RESET'));

        await dispatch(CustomerGetAction(query));

      } catch (error) {
        setIsError(true);
        return;
      }
      setIsError(false);
      setLoading(false);
      setIsRefetching(false);
    };
    fetchData();
  }, [
    columnFilters,
    // searchValue,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    !UpdateStatus.loading,
    openSerach
  ]);
  useEffect(() => {
    setData(customerlist?.data?.data?.rows);
    setRowCount(customerlist?.data?.data?.count);
  }, [customerlist?.data, !UpdateStatus.loading]);



  const handleSearchBystatus = (Id: any) => {
    setColumnFilters([{ id: "status", value: Id }])
  }
 
  const handeldate = (e: any) => {
    const formattedDate = moment(e).format('YYYY-MM-DD');
    setStartDate(formattedDate);
  }

  const handelEnddate = (e: any) => {
    const formattedDate = moment(e).format('YYYY-MM-DD');
    setEndDate(formattedDate)
  }
  const resetSearchfilter = () => {
    setOpenSerach(false)
    setStartDate('')
    setEndDate('')
    setSearchValue('')
    if (formRef.current) {
      formRef.current.reset();
    }
    const columnFilters = [
      { id: "start_date", value: "" },
      { id: "end_date", value: "" },
      { id: "search", value: "" }
    ]
    setColumnFilters(columnFilters)

  }
  const handleserach = (e: any) => {
    e.preventDefault()
    const columnFilters = [
      { id: "start_date", value: startDate.trim() },
      { id: "end_date", value: endDate.trim() },
      { id: "search", value: searchValue.trim() }
    ]
    setColumnFilters(columnFilters)
    setOpenSerach(true)
  }
  return (
    <Fragment>
      {(loading || customerlist?.loading) ? <Spinner /> : ""}


      <PageLayout
        title={intl.formatMessage({ id: 'customer_management' })}
        breadcrumbs={{
          secLast: { 'link': '/customer-management-list', 'name': intl.formatMessage({ id: 'customer_management' }) },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false },
        ]}
      >
        <form ref={formRef} onSubmit={handleserach}>
          <div className="row gy-3">
            <div className='col-md-6 col-lg-4 col-xl-3'>
              <div className="input-group w-100">
                <div className="input-group">
                  <span className="input-group-text fa-solid fa-magnifying-glass " id="basic-addon1"> <i className="fas fa-search"></i></span>
                  <input type='text' id="saerchId" className="form-control m-0" placeholder={intl.formatMessage({ id: 'search_by_name' })} onChange={(e) => setSearchValue(e.target.value.trim())} />
                </div>
              </div>
            </div>
            <div className="col-6">
              <button className='btn theme-bg text-white me-2'><FormattedMessage id="filter" /></button>
              <button className='btn btn-success' onClick={() => resetSearchfilter()} ><FormattedMessage id="reset" /></button>
            </div>
          </div>
          <div className='row gy-3 mt-3 mb-4'>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="start_date" /></label>
              <DatePicker className="form-control"  placeholderText={intl.formatMessage({ id: 'date_placeholder' })}  value={startDate ? getDateFormatData(startDate) : ''} onChange={(e) => handeldate(e)}  onKeyDown={(e) => e.preventDefault()}/>
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="end_date" /></label>
              <DatePicker className="form-control" placeholderText={intl.formatMessage({ id: 'date_placeholder' })} value={endDate ? getDateFormatData(endDate) : ''} onChange={(e) => handelEnddate(e)} minDate={new Date(startDate)} onKeyDown={(e) => e.preventDefault()} />
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="all_users" /></label>
              <select className='form-select shadow-none' name="users" id="cars" onChange={(e) => handleSearchBystatus(e.target.value)}>
                <option value="">{intl.formatMessage({ id: 'all_users' })}</option>
                <option value="1">{intl.formatMessage({ id: 'active_users' })}</option>
                <option value="0">{intl.formatMessage({ id: 'deactive_users' })}</option>
              </select>
            </div>
          </div>
        </form>
        {
          data &&
          <MaterialReactTable
            columns={columns}
            data={data}
            enableGlobalFilter={true}

            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={isError ? { color: 'error', children: intl.formatMessage({ id: 'error_loading_data' }), } : undefined}
            muiSearchTextFieldProps={{
              placeholder: intl.formatMessage({ id: 'search_from_name' }),
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) => handleSearch(
              value,
              setIsError,
              setLoading,
              setIsRefetching,
              setSearchValue,
            )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        }
        <ToastDefault />
      </PageLayout>
    </Fragment>
  )
}

export default CustomerManagement